module.exports = __webpack_public_path__ + "img/logo-aula4.fab53e25.jpeg";